import {useTranslation} from "react-i18next";
import {AvailableLoadsByInsight, AvailableLoadsByInsightProps} from "./AvailableLoadsByInsight";

export type AvailableLoadsByRouteInsightProps = Omit<AvailableLoadsByInsightProps, 'title' | "defaultType" | "showSelect">

export const AvailableLoadsByRouteInsight = (props: AvailableLoadsByRouteInsightProps) => {
  const {...rest} = props

  const {t} = useTranslation()

  return (
    <AvailableLoadsByInsight
      {...rest}
      title={t<string>("common.insight.availloadsbyroute", "Avail. Loads By Route")}
      defaultType="route"/>
  )
}
